// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1DUHh","buttons":"Footer_buttons__193hH"};